const GoogleIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3761 13.2527C24.3761 12.3174 24.2987 11.6349 24.1311 10.9271H13.2333V15.1485H19.63C19.5011 16.1975 18.8047 17.7774 17.2571 18.839L17.2354 18.9803L20.681 21.5963L20.9198 21.6196C23.1122 19.6353 24.3761 16.7157 24.3761 13.2527Z"
      fill="#4285F4"
    />
    <path
      d="M13.2326 24.3748C16.3665 24.3748 18.9974 23.3636 20.9191 21.6195L17.2564 18.8389C16.2763 19.5087 14.9608 19.9764 13.2326 19.9764C10.1632 19.9764 7.55808 17.9921 6.62942 15.2495L6.4933 15.2608L2.91044 17.9782L2.86359 18.1058C4.77229 21.8217 8.69292 24.3748 13.2326 24.3748Z"
      fill="#34A853"
    />
    <path
      d="M6.63007 15.2497C6.38504 14.542 6.24323 13.7836 6.24323 13C6.24323 12.2163 6.38504 11.458 6.61718 10.7503L6.61069 10.5995L2.98292 7.8385L2.86422 7.89383C2.07755 9.43579 1.62616 11.1674 1.62616 13C1.62616 14.8326 2.07755 16.5641 2.86422 18.1061L6.63007 15.2497Z"
      fill="#FBBC05"
    />
    <path
      d="M13.2326 6.0233C15.4122 6.0233 16.8824 6.94594 17.7207 7.71696L20.9965 4.5825C18.9846 2.74987 16.3665 1.625 13.2326 1.625C8.69289 1.625 4.77224 4.17804 2.86353 7.89384L6.61649 10.7503C7.55805 8.00763 10.1632 6.0233 13.2326 6.0233Z"
      fill="#EB4335"
    />
  </svg>
);

export default GoogleIcon;
